import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

export default function UserEventDetail() {
  const { token, user } = useAuth();
  const { id } = useParams();
  const [event, setEvent] = useState(null);
  const [message, setMessage] = useState('');

  const isRegistered = () =>
    event?.rsvps?.some(r => r.userId === user?.id);

  useEffect(() => {
    fetch(`https://techservicemarket-backend.onrender.com/api/events/${id}`, {
      headers: { Authorization: `Bearer ${token}` }
    })
      .then(res => res.json())
      .then(data => setEvent(data))
      .catch(err => console.error('Fetch error:', err));
  }, [id, token]);

  const handleRegister = async () => {
    try {
      const res = await fetch(`https://techservicemarket-backend.onrender.com/api/events/${id}/rsvp`, {
        method: 'POST',
        headers: { Authorization: `Bearer ${token}` }
      });
      const updated = await res.json();
      if (!res.ok) throw new Error(updated.message);
      setEvent(updated);
      setMessage('Registration successful');
    } catch (err) {
      setMessage(err.message || 'Registration failed');
    }
  };

  const handleCancel = async () => {
    try {
      const res = await fetch(`https://techservicemarket-backend.onrender.com/api/events/${id}/rsvp`, {
        method: 'DELETE',
        headers: { Authorization: `Bearer ${token}` }
      });
      const updated = await res.json();
      if (!res.ok) throw new Error(updated.message);
      setEvent(updated);
      setMessage('Registration cancelled');
    } catch (err) {
      setMessage(err.message || 'Cancellation failed');
    }
  };

  if (!event) return <p style={{ textAlign: 'center' }}>Loading event...</p>;

  return (
    <div style={{ maxWidth: '700px', margin: '0 auto', padding: '2rem' }}>
      <h2 style={{ textAlign: 'center', color: '#1e40af' }}>Upcoming Events</h2>
      {message && <p style={{ color: '#047857', textAlign: 'center' }}>{message}</p>}

      <div style={{
        backgroundColor: '#f9fafb',
        borderRadius: '12px',
        padding: '2rem',
        boxShadow: '0 2px 10px rgba(0,0,0,0.1)'
      }}>
        <h3 style={{ textAlign: 'center', color: '#111827', marginBottom: '1rem' }}>{event.title}</h3>
        <p><strong>Date:</strong> {new Date(event.eventDate).toLocaleString()}</p>
        <p><strong>Location:</strong> {event.location}</p>
        <p><strong>Registered:</strong> {event.attendanceCount}</p>
        <p style={{ color: '#6b7280' }}>
          Hosted by: {event.author?.username} ({event.author?.role})
        </p>
        <button
          onClick={isRegistered() ? handleCancel : handleRegister}
          style={{
            marginTop: '1rem',
            padding: '0.5rem 1.5rem',
            backgroundColor: isRegistered() ? '#6b7280' : '#1e40af',
            color: 'white',
            border: 'none',
            borderRadius: '6px',
            fontWeight: 'bold',
            cursor: 'pointer'
          }}
        >
          {isRegistered() ? 'Cancel Registration' : 'Register'}
        </button>
      </div>
    </div>
  );
}
